import { gql } from '@apollo/client';

export const REQUEST_OTP_MUTATION = gql`
  mutation MeetRequestForgetPasswordOtp($email: String!, $source: String) {
    meetRequestForgetPasswordOtp(email: $email, source: $source) {
      emailId
      expiresAt
      message
      type
    }
  }
`;

export const VERIFY_OTP_MUTATION = gql`
  mutation MeetValidateOtp($code: String!, $email: String!) {
    meetValidateOtp(code: $code, email: $email) {
      message
    }
  }
`;

export const RECOVERY_USERNAME_MUTATION = gql`
  mutation MeetRecoveryMyUsername($emailId: String!) {
    meetRecoveryMyUsername(emailId: $emailId) {
      emailId
      message
      status
    }
  }
`;

export const RESET_PASSWORD_MUTATION = gql`
  mutation MeetResetPassword($code: String!, $email: String!, $newPassword: String!) {
    meetResetPassword(code: $code, email: $email, newPassword: $newPassword) {
      message
    }
  }
`;
